// src/store/usersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
   getUsers as apiGetUsers,
   updateUser as apiUpdateUser, // 👈 alias pt. service
   deleteUser as apiDeleteUser,
} from "../api/usersService";
import { unwrapList } from "../utils/groupFields";
import { rememberKnownAvatars } from "../utils/userAvatar";

// listare
export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
   const users = await apiGetUsers();
   const list = unwrapList(users);
   // pozele din listă ajung în toate cercurile (și unde omul vine fără câmpul pozei)
   rememberKnownAvatars(list);
   return list;
});

// ✨ update user (ex: privateMessage)
export const updateUser = createAsyncThunk(
   "users/updateUser",
   async ({ id, data }) => {
      const updated = await apiUpdateUser(id, data);
      // poate veni fie ca obiect direct, fie {data: {...}}
      return updated?.data ?? updated;
   }
);

// ștergere cont de personal (manager / admin / profesor)
export const removeUser = createAsyncThunk("users/removeUser", async (id) => {
   await apiDeleteUser(id);
   return id;
});

const usersSlice = createSlice({
   name: "users",
   initialState: {
      list: [],
      status: "idle",
      error: null,
      updating: false,
   },
   reducers: {},
   extraReducers: (builder) => {
      builder
         // fetch
         .addCase(fetchUsers.pending, (state) => {
            state.status = "loading";
            state.error = null;
         })
         .addCase(fetchUsers.fulfilled, (state, action) => {
            state.status = "succeeded";
            state.list = action.payload || [];
            state.error = null;
         })
         .addCase(fetchUsers.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.error?.message || "Failed to load users";
         })

         // update
         .addCase(updateUser.pending, (state) => {
            state.updating = true;
         })
         .addCase(updateUser.fulfilled, (state, action) => {
            state.updating = false;
            const u = action.payload;
            if (!u?.id) return;
            const idx = state.list.findIndex(
               (x) => String(x.id) === String(u.id)
            );
            if (idx >= 0) state.list[idx] = { ...state.list[idx], ...u };
            else state.list.push(u); // fallback dacă nu era în listă
         })
         .addCase(updateUser.rejected, (state, action) => {
            state.updating = false;
            state.error = action.error?.message || "Failed to update user";
         })

         // remove
         .addCase(removeUser.fulfilled, (state, action) => {
            state.list = state.list.filter(
               (x) => String(x.id) !== String(action.payload)
            );
         });
   },
});

export default usersSlice.reducer;
